// extracted by mini-css-extract-plugin
export default {"wrapper":"qk","form":"rk","required":"sk","label":"tk","noMargin":"uk","success":"vk","circle":"wk","successText":"xk","smallprint":"yk"};